import {mapGetters} from "vuex";

import {VueSlideToggle} from 'vue-slide-toggle'
import PackageAccessNotice from '@/components/features/package-access-notice/index.vue'
import activeItemModule from '../../components/active-item-module/index.vue'


export default {
    name: 'active-item-homework',
    props: {
        item: {
            type: Object,
            default: {}
        },
        course: {
            type: Object,
            default: {}
        },
    },
    data() {
        return {
            isShowItemList: false,
            countHomeWork: 0
        }
    },
    components: {
        VueSlideToggle,
        activeItemModule,
        PackageAccessNotice,
    },
    computed: {
        ...mapGetters({}),
        statuses() {
            return Object.entries(this.item.summary.data.statuses)
        },
    },
    mounted() {
        this.$nextTick(() => {
            console.log(this.item.summary.data.statuses.onChecking);
        })
    },
    created() {
        if (this.item) {
            this.getCount();
        }
    },
    methods: {
        getCount() {
            this.countHomeWork = this.item.userWorks.data.length;
        }
    }
}
